import WorkingAreasPage from './WorkingAreas';

export default WorkingAreasPage;
